import type React from 'react';

import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { ViewWrapper } from '@/components/viewWrapper/ViewWrapper.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { GeneralErrorTitleStyles } from '@/views/generalError/generalError.styles.ts';

interface Props {
  /** Replaces the default go-back button row when provided. */
  actions?: React.ReactNode;
  hideButtons?: boolean;
  message: string;
  subMessage?: string;
}

export const GeneralError: React.FC<Props> = props => {
  const { actions, hideButtons, message, subMessage } = props;
  const { t } = useTranslationWithPrefix('generalError');

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <>
      <ViewWrapper>
        <Typography sx={GeneralErrorTitleStyles} variant="f24Medium">
          <ErrorIcon />
          {t('title')}
          <ErrorIcon />
        </Typography>
        <Divider />
        <Typography variant="f16Regular">
          <Box sx={{ pt: 8, textAlign: 'center' }}>{message}</Box>
          {subMessage && <Box sx={{ pt: 4, textAlign: 'center' }}>{subMessage}</Box>}
        </Typography>
        {actions ? (
          <Box sx={{ pt: 8, textAlign: 'center' }}>{actions}</Box>
        ) : (
          hideButtons !== true && (
            <Box sx={{ pt: 8, textAlign: 'center' }}>
              <Button onClick={handleGoBack} variant="outlined">
                {t('goBack')}
              </Button>
            </Box>
          )
        )}
      </ViewWrapper>
    </>
  );
};
